// Web CDN entry — auto-registers <adland-slot> with the web adapter. Carries
// zero Farcaster code. Built to dist/adland.js.
import { WebActionAdapter } from "@adland/react/core";
import { registerAdlandSlot } from "../register";

registerAdlandSlot(WebActionAdapter);
